export default class DeserializedAsset {
  constructor(a) {
    Object.assign(this, a);
    this.docId = a.docId === "null" ? undefined : a.docId;
  }
}
